export default {
    VERIFY_2FA_FORM__CHANGE_CODE: 'VERIFY_2FA_FORM__CHANGE_CODE',
    VERIFY_2FA_FORM__ERROR: 'VERIFY_2FA_FORM__ERROR',
    VERIFY_2FA_FORM__RESEND: 'VERIFY_2FA_FORM__RESEND',
    VERIFY_2FA_FORM__SUBMIT: 'VERIFY_2FA_FORM__SUBMIT',
    VERIFY_2FA_FORM__TOGGLE_TRUSTED: 'VERIFY_2FA_FORM__TOGGLE_TRUSTED',
    VERIFY_2FA_FORM__VERIFIED: 'VERIFY_2FA_FORM__VERIFIED',
    VERIFY_2FA_FORM__CLEAR_SECONDS: 'VERIFY_2FA_FORM__CLEAR_SECONDS',
};
